import { SearchFormInputs, INITIAL_PASSENGERS } from "src/Modules/Flights/constants";
import { explode } from "src/utility/objects";
import { formatDate } from "src/utility/time";

const perpareSeachObjectChipValues = (searchObject: SearchFormInputs) => {
  const { journeyType, preferredDepartureTime, preferredReturnTime, passengers, origin, destination } = explode(searchObject, {
    passengers: INITIAL_PASSENGERS,
  });
  const isRoundTrip = journeyType === 2;
  const depTime = formatDate(preferredDepartureTime, "MMM DD, YYYY");
  const returnTime = formatDate(preferredReturnTime, "MMM DD, YYYY");
  const numPassengers = (Object.values(passengers) as number[]).reduce((prev, next) => next + prev, 0);
  const originLabel = origin?.label;
  const destinationLabel = destination?.label;
  return {
    isRoundTrip,
    depTime,
    returnTime,
    numPassengers,
    originLabel,
    destinationLabel,
  };
};

export {perpareSeachObjectChipValues};
